import { render, staticRenderFns } from "./Bloc.vue?vue&type=template&id=32d8e5ea&scoped=true"
import script from "./Bloc.vue?vue&type=script&lang=js"
export * from "./Bloc.vue?vue&type=script&lang=js"
import style0 from "./Bloc.vue?vue&type=style&index=0&id=32d8e5ea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d8e5ea",
  null
  
)

export default component.exports